import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './components/Steps'
import { version } from '../package.json';

function App() {
  return (
    <div className="App">
        <Home/>
        <span style={{ position: "absolute", left: 0, bottom: 0, fontSize: "10px" }}>v{version}</span>
    </div>
  );
}

export default App;
